import React from "react";
import {
  AbsoluteFill,
  interpolate,
  spring,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";
import { GridBackground } from "../EAKCArchitecture/components/GridBackground";
import { StatCounter } from "../shared/StatCounter";
import { COLORS, FONTS, SPRING } from "./constants";

const STATS_ROW_1 = [
  { value: 27465, suffix: "", prefix: "", label: "Knowledge Chunks", color: COLORS.accentTeal, delay: 10 },
  { value: 140, suffix: "", label: "Active Users", color: COLORS.accentBlue, delay: 25 },
  { value: 556, suffix: "", label: "Chat Sessions", color: COLORS.accentPurple, delay: 40 },
  { value: 787, suffix: "", label: "Messages Sent", color: COLORS.accentPink, delay: 55 },
  { value: 8, suffix: "", label: "Tenants", color: COLORS.accentOrange, delay: 70 },
];

const STATS_ROW_2 = [
  { value: 45, suffix: "", label: "Knowledge Sources", color: COLORS.accentGreen, delay: 85 },
  { value: 15132, suffix: "", label: "Unique Documents", color: COLORS.accentYellow, delay: 100 },
  { value: 13, suffix: "", label: "Code Languages", color: COLORS.accentPurple, delay: 115 },
  { value: 6, suffix: "", label: "Generation Modes", color: COLORS.accentPink, delay: 130 },
  { value: 6, suffix: "", label: "Source Integrations", color: COLORS.accentBlue, delay: 145 },
];

export const Scene10Stats: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const titleProgress = spring({
    frame: frame - 5,
    fps,
    config: SPRING.snappy,
  });
  const titleOpacity = interpolate(titleProgress, [0, 1], [0, 1]);
  const titleY = interpolate(titleProgress, [0, 1], [20, 0]);

  // Fade out at end
  const exitFade = interpolate(frame, [700, 750], [1, 0], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });

  return (
    <AbsoluteFill style={{ opacity: exitFade }}>
      <GridBackground />

      {/* Title */}
      <div
        style={{
          position: "absolute",
          top: 60,
          left: 0,
          right: 0,
          textAlign: "center",
          fontFamily: FONTS.heading,
          fontSize: 44,
          fontWeight: 700,
          color: COLORS.textPrimary,
          opacity: titleOpacity,
          transform: `translateY(${titleY}px)`,
        }}
      >
        By The Numbers
      </div>

      {/* Stats Grid — holds for full scene */}
      <div
        style={{
          position: "absolute",
          top: 220,
          left: 0,
          right: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 80,
        }}
      >
        {/* Row 1 */}
        <div style={{ display: "flex", gap: 60, justifyContent: "center" }}>
          {STATS_ROW_1.map((s) => (
            <StatCounter
              key={s.label}
              value={s.value}
              suffix={s.suffix}
              prefix={s.prefix}
              label={s.label}
              color={s.color}
              delay={s.delay}
              fontSize={48}
              labelSize={14}
              duration={50}
            />
          ))}
        </div>
        {/* Row 2 */}
        <div style={{ display: "flex", gap: 60, justifyContent: "center" }}>
          {STATS_ROW_2.map((s) => (
            <StatCounter
              key={s.label}
              value={s.value}
              suffix={s.suffix}
              label={s.label}
              color={s.color}
              delay={s.delay}
              fontSize={48}
              labelSize={14}
              duration={50}
            />
          ))}
        </div>
      </div>

      {/* Subtitle */}
      {(() => {
        const subAppear = spring({ frame: frame - 180, fps, config: SPRING.gentle });
        return (
          <div
            style={{
              position: "absolute",
              bottom: 120,
              left: 0,
              right: 0,
              textAlign: "center",
              fontFamily: FONTS.body,
              fontSize: 18,
              color: COLORS.textMuted,
              opacity: interpolate(subAppear, [0, 1], [0, 1]),
            }}
          >
            Real metrics from production — continuously improving every week
          </div>
        );
      })()}
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
